import AnalyticsMainHandler from '@common/utils/analytics/analytics.main';

function remindAboutImpersonation(app) {
  const action = {
    text: 'Stop',
    onClick: () => {
      stopImpersonation(app);
    },
  };
  app.$toasted.success(`Impersonating ${app.$store.getters.impersonatedUserEmailState}`, {action});
}

export function setImpersonation(app, userEmail) {
  app.$store.commit('setImpersonatedUserState', {email: userEmail});
  app.$store.commit(
    'setNextRefreshTimeState',
    new Date().getTime() + parseInt(process.env.VUE_APP_REFRESH_TOKEN_TIMEOUT)
  );
  app.$store.dispatch('refreshMyInformationAction').then(response => {
    if (response.impersonator) {
      app.$store.commit('clearActiveFamilyTreeIdState');
      app.$toasted.success(`Impersonated ${app.$store.getters.impersonatedUserEmailState}`);
      AnalyticsMainHandler.stopTracking();
    } else {
      app.$store.commit('setImpersonatedUserState', null);
      app.$store.commit('setImpersonatedUserFamilyTreeIdState', null);
      app.$store.commit('clearActiveFamilyTreeIdState');
      app.$toasted.error(`Log in as staff to impersonate ${userEmail}`, {duration: 5000});
    }
  });
}

export function stopImpersonation(app) {
  app.$store.commit('setImpersonatedUserState', null);
  app.$store.commit('setImpersonatedUserFamilyTreeIdState', null);
  app.$store.commit('clearActiveFamilyTreeIdState');
  app.$toasted.success('Impersonation stopped.');
  app.$store.commit(
    'setNextRefreshTimeState',
    new Date().getTime() + parseInt(process.env.VUE_APP_REFRESH_TOKEN_TIMEOUT)
  );
  app.$store.dispatch('refreshMyInformationAction').then(() => {
    window.location.replace(process.env.VUE_APP_WEB_SITE_BASE);
  });
}

export function handleImpersonationOnRouteChange(from, to, app) {
  if (!app.$store.getters.impersonatedUserEmailState && !to.query.impersonate) {
    return;
  }

  if (!from.name && app.$store.getters.impersonatedUserEmailState && !to.query.impersonate) {
    return remindAboutImpersonation(app);
  }
  if (to.query.impersonate) {
    return setImpersonation(app, to.query.impersonate);
  }
}
